import React, { useEffect, useState } from 'react';
import { Modal, Tabs } from 'antd';
import InfoTab from './ParticipantDetailsTabs/InfoTab';
import BadgesTab from './ParticipantDetailsTabs/BadgesTab';
import LeadsTab from './ParticipantDetailsTabs/LeadsTab';
import ProgrammeBookingsTab from './ParticipantDetailsTabs/ProgrammeBookingsTab';
import HotelBookingsTab from './ParticipantDetailsTabs/HotelBookingsTab';
import InvoicesTab from './ParticipantDetailsTabs/InvoicesTab';
import FilesTab from './ParticipantDetailsTabs/FilesTab';

const { TabPane } = Tabs;

const ModalParticipantDetails = ({
                                     open,
                                     participant,
                                     host,
                                     onClose,
                                     programmePoints,
                                     participantTypes,
                                     participantStates
                                 }) => {
    const [activeTab, setActiveTab] = useState('info');

    useEffect(() => {
        // Reset tab to "info" whenever modal opens or participant changes
        if (open && participant) {
            setActiveTab('info');
        }
    }, [open, participant?.key]);

    if (!participant) return null;

    return (
        <Modal
            open={open}
            title={`${participant.firstName} ${participant.lastName}`}
            footer={null}
            onCancel={onClose}
            width={1200}
        >
            <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                destroyInactiveTabPane
            >
                <TabPane tab="Info" key="info">
                    <InfoTab
                        participantId={participant.key}
                        host={host}
                        participantTypes={participantTypes}
                        participantStates={participantStates}
                    />
                </TabPane>
                <TabPane tab="Badges" key="badges">
                    <BadgesTab participantId={participant.key} host={host} />
                </TabPane>
                <TabPane tab="Leads" key="leads">
                    <LeadsTab participantId={participant.key} host={host} programmePoints={programmePoints} />
                </TabPane>
                <TabPane tab="Bookings" key="bookings">
                    <ProgrammeBookingsTab
                        participantId={participant.key}
                        host={host}
                        programmePoints={programmePoints}
                    />
                </TabPane>
                <TabPane tab="Hotels" key="hotels">
                    <HotelBookingsTab participantId={participant.key} host={host} />
                </TabPane>
                <TabPane tab="Invoices" key="invoices">
                    <InvoicesTab participantId={participant.key} host={host} />
                </TabPane>
                <TabPane tab="Files" key="files">
                    <FilesTab participantId={participant.key} host={host} />
                </TabPane>
            </Tabs>
        </Modal>
    );
};

export default ModalParticipantDetails;